import { Accordion, AccordionDetails } from '@mui/material';
import { styled } from '@/core/ui';
import { GroupedListItemTopAnchor } from '../GroupedListItem';
export const GroupedListItemAccordion = styled(Accordion)({
//
});
export const GroupedListItemAccordionDetails = styled(AccordionDetails)({
    padding: 0,
});
export const GroupedListItemTopAnchorAbsolute = styled(GroupedListItemTopAnchor)({
    position: 'absolute',
    top: -14,
    left: 0,
});
